import * as yup from 'yup';
import { FIELD } from 'screens/BrokerPortal/screens/Registration/components/SearchFirmsStep/types';

export const validationSchema = () =>
  yup.object().shape({
    [FIELD.FIRM_ID]: yup
      .number()
      .nullable()
      .required('This field is required'),
  });
